module.exports = __webpack_public_path__ + "img/inside2.a0ca4c42.gif";